const stack = [
    "OpenAI",
    "Anthropic",
    "Google Gemini",
    "Stripe",
    "React",
    "FastAPI",
    "MongoDB",
    "Vercel",
];

export default function LogoMarquee() {
    const row = [...stack, ...stack];
    return (
        <section
            data-testid="logo-marquee"
            className="relative py-14 border-y border-white/5 overflow-hidden"
        >
            <p className="text-center text-[11px] font-bold uppercase tracking-[0.25em] text-[#475569] mb-8 px-6">
                The production stack we build on
            </p>

            <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#050b14] to-transparent z-10 pointer-events-none" />
            <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#050b14] to-transparent z-10 pointer-events-none" />

            <div className="flex marquee w-max gap-16 items-center">
                {row.map((name, i) => (
                    <span
                        key={i}
                        className="font-heading text-xl font-semibold tracking-tight text-[#64748b] hover:text-white transition-colors shrink-0 whitespace-nowrap"
                    >
                        {name}
                    </span>
                ))}
            </div>
        </section>
    );
}
